// @ts-nocheck
import { memo } from "react";
import { Fragment, h } from "preact";
import { useController, UseControllerProps } from "react-hook-form";
import { compareRender } from "../../../functions/form";
import { Row, Select as SelectAntd } from "antd";
import { TextLink, Text } from "../../text";
import { useMemo, useRef, useState } from "preact/hooks";
import { ModalEdit } from "./view/modal/edit";

const { Option } = SelectAntd;

interface IProperties {
  options: any[];
  valueKey?: string;
  labelKey?: string;
  columns?: any[];
}

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  placeholder?: string;
  mode: "multiple";
  disabled?: boolean;
  properties: IProperties;
}
interface ISelect {
  control?: any;
  item: IItem;
  handleChange?: any;
}

const SelectModal = ({ control, item, handleChange }: ISelect) => {
  const modalRef = useRef<IModalRef>();
  const {
    ref,
    rules,
    name,
    defaultValue,
    placeholder,
    label,
    mode,
    properties,
    disabled,
    onCallbackEdit,
  } = item;
  const { options, valueKey, labelKey, columns } = properties;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;
  const [selectedItems, setSelectedItems] = useState([]);

  const opt = useMemo(() => {
    return options.map((e) => {
      const val = valueKey ? e[valueKey] : e;
      const lab = labelKey ? e[labelKey] : e;
      return (
        <Option value={val} {...e}>
          {lab}
        </Option>
      );
    });
  }, [options]);

  function onCallbackModalEdit(opt) {
    setSelectedItems(opt);
    onCallbackEdit && onCallbackEdit(opt);
  }

  return (
    <>
      <Row justify="space-between">
        {label && <Text size={"XS"} text={label} bold={true} />}
        {!disabled && value && value.length > 0 && (
          <TextLink
            text="แก้ไข"
            onClick={() =>
              modalRef.current && modalRef.current.openModal(selectedItems)
            }
          />
        )}
      </Row>
      <SelectAntd
        showSearch
        showArrow
        allowClear
        id={ref}
        value={value || []}
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={(e, option) => {
          setSelectedItems(
            option.map((el) => {
              const { key, value, children, ...o } = el;
              return o;
            })
          );
          handleChange(e, item, option);
        }}
        style={{ width: "100%" }}
        mode={mode || undefined}
        disabled={disabled}
      >
        {opt as React.ReactNode}
      </SelectAntd>
      {error &&
        ((
          <TextXSMall text={error.message} color="red" bold />
        ) as React.ReactNode)}
      <ModalEdit
        ref={modalRef}
        columns={columns}
        onCallbackEdit={onCallbackModalEdit}
        item={properties}
      />
    </>
  );
};

export const MemoizedSelectModal = memo(
  SelectModal,
  (prev, next) =>
    compareRender(prev, next) &&
    JSON.parse(JSON.stringify(prev.item.properties.options)) ===
      JSON.parse(JSON.stringify(next.item.properties.options))
);
